export default {
  id: 'ContactTimeLine',
  code: 'CN',
  text: {
    'Edit': '编辑',
    'Delete': '删除',
    'created this note': '创建了这个备忘'
  }
}
 


// WEBPACK FOOTER //
// ./src/components/UI/ContactTimeline/locale.js